var _circle, _circle2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmartPlug = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#F5F5F5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#FF8080",
  className: "smart-plug_svg__sensor-connection-status"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "gray",
  className: "smart-plug_svg__sensor-no-status"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 46 7 7M56 46l-7 7"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#003252",
  clipPath: "url(#smart-plug_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.333 28.334a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667M32.667 28.334a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667M30 26.334a.667.667 0 1 1 0 1.333.667.667 0 0 1 0-1.333"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M30 23a6.667 6.667 0 1 1 0 13.334A6.667 6.667 0 0 1 30 23m0 1.334a5.333 5.333 0 1 0 0 10.667 5.333 5.333 0 0 0 0-10.667",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M38 19a2.667 2.667 0 0 1 2.667 2.667v16A2.667 2.667 0 0 1 38 40.334H22a2.667 2.667 0 0 1-2.667-2.667v-16A2.667 2.667 0 0 1 22 19.001zm-16 2a.667.667 0 0 0-.667.667v16c0 .368.299.667.667.667h16a.667.667 0 0 0 .667-.667v-16a.667.667 0 0 0-.667-.666z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.339 17.458c.037-.26.384-.417.733-.29a4.07 4.07 0 0 1 2.416 2.425c.126.35-.03.699-.289.736-.26.037-.504-.149-.6-.409a3.1 3.1 0 0 0-1.853-1.86c-.26-.096-.445-.342-.407-.602M40.309 15.026a6.36 6.36 0 0 1 4.329 4.343c.096.32-.066.633-.325.685-.26.052-.511-.141-.593-.416a5.42 5.42 0 0 0-3.685-3.698c-.267-.075-.46-.328-.415-.595l.008.007c.044-.252.355-.415.68-.327"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "smart-plug_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14 13.667h32v32H14z"
})))));
export default SvgSmartPlug;